
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/convert",
      function () {
        return require("private-next-pages/convert/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/convert"])
      });
    }
  